import { Form, Field, FormElement, FieldWrapper } from '@progress/kendo-react-form';
import React,{ useState , useEffect} from 'react';
import FormContainer from '../components/FormContainer';
import {  Error  } from '@progress/kendo-react-labels';
import { CusFormLabel, FormTitle, FormUploadView, TermsFormCheckbox} from '../validation/Form-Components';
import { useHistory } from "react-router-dom";
import CusProgressBar from '../components/CusProgressBar';
import config from '../appconfig/config.json';
import service from '../services/ApiService.js';
import uploadService from '../services/UploadFilesService.js';
import Loading from '../components/Loading';
import CusRadioButton from '../components/CusRadioButton';
import { uploadTermsValidator } from '../validation/Validators';
import helper from '../factory/Helper.js';
import uploadConfig from '../data/uploaddetailsdata.json';
import ImgPopup from '../components/ImgPopup';
import CusToast from '../components/CusToast';
import axios from 'axios';
import storage from '../factory/StorageFactory.js';
 
let signatureId='0',pdfId='0',acsId='0',imgStr='';

const ACSUploadDetails = (props) => {

    let timer;
    const history = useHistory();
    const item = { bgcolor: "#389A6E", completed: 80 };
    const detailsType = '7';
    const seq0='0', seq1='1',seq2='2',seq3='3';

    const typeMemorandum ='Memorandum', typeSignature='Signature', typeACS = 'MinutesOfMeeting';

    const pdfFileNameCharRegex = new RegExp(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/);

    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [checkedAdoptAcraTemplate,setCheckedAdoptAcraTemplate] = useState('N');
 
    const [selectedPdfACS,setSelectedPdfACS] = useState([]);
    const [selectedPdf, setSelectedPdf] = useState([]);
    const [selectedSignature, setSelectedSignature] = useState([]);

    const [isSaveSignDone, setIsSaveSignDone] = useState(false);
    const [isSavePdfDone, setIsSavePdfDone] = useState(false);
    const [isSaveDone, setIsSaveDone] = useState(false);
    const [uploadedPdf,setUploadedPdf] = useState();
    const [uploadedSignature,setUploadedSignature] = useState();
    const [uploadedPdfACS,setUploadedPdfACS] = useState();
    const [showImgPopup,setShowImgPopup] = useState(false);

    const [initFormData, setInitFormData] = useState({DocClare:false});

    const [uploadMemoErr,setUploadMemoErr] = useState(false);
    const [memoErrMsg,setMemoErrMsg] = useState('');

    const [uploadACSErr,setUploadACSErr] = useState(false);
    const [acsErrMsg,setACSErrMsg] = useState('');

    const [uploadSignErr,setUploadSignErr] = useState(false);
    const [signErrMsg,setSignErrMsg] = useState('');
 
    const initResState = {
        RefNum:'',
        CompDtls:{}, 
        ApplicantDtls:[],
        ApplicantsDtlsMyInfo:{},
        DocSubmit:{}
    }
    const [response, setResponse] = useState(initResState);

    useEffect(() => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        window.scrollTo(0,0);
        getData();
        
        return () => clearTimeout(timer);
     }, [setResponse]);

   
    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess) {
                bindFormData(res.data.model.fields.request)
                bindDocClare(res.data.model.fields.request)
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
            setIsLoading(false);
            showErrMsg('Error: Get data failed.')
        })
    }
    
    const bindFormData = (data) => {
        try{
            setResponse(data);  //asign api response
            setCheckedAdoptAcraTemplate(data.DocSubmit.AdoptAcraTemplate);
            if(data.DocSubmit.Doc) {
               
                if(!Array.isArray(data.DocSubmit.Doc)) { //obj
                  
                    if(data.DocSubmit.Doc.DocType === typeSignature){
                        if(data.DocSubmit.Doc.NRIC === data.ApplicantsDtlsMyInfo.IDNum) { 
                         
                            signatureId =data.DocSubmit.Doc.id;
                            setSelectedSignature(getDefFileArray(data.DocSubmit.Doc.File));
                            setUploadedSignature(data.DocSubmit.Doc.File);
                            setIsSaveSignDone(true);
                        }
                        else {
                            setIsSaveSignDone(false);
                            signatureId='0';
                            setSelectedSignature([]);
                        } 
                    }
                    else if(data.DocSubmit.Doc.DocType === typeMemorandum) {
                       
                        pdfId = data.DocSubmit.Doc.id;
                        setSelectedPdf(getDefFileArray(data.DocSubmit.Doc.File));
                        setUploadedPdf(data.DocSubmit.Doc.File);
                        setIsSavePdfDone(true);
                    }
                    else if(data.DocSubmit.Doc.DocType === typeACS){
                    
                        acsId = data.DocSubmit.Doc.id;
                        setSelectedPdfACS(getDefFileArray(data.DocSubmit.Doc.File));
                        setUploadedPdfACS(data.DocSubmit.Doc.File);
                        setIsSaveDone(true);
                    }
                    else {
                        signatureId = '0';
                        pdfId = '0';
                        acsId= '0';
                        setIsSaveDone(false);
                        setIsSavePdfDone(false);
                        setIsSaveSignDone(false);
                        setSelectedSignature([]);
                        setSelectedPdf([]);
                        setSelectedPdfACS([]);
                    }
                }
                else { //array
                    let docArray = data.DocSubmit.Doc;
                    for(let i in docArray) {
                        if(docArray[i].DocType === typeSignature) {
                            if(docArray[i].NRIC === data.ApplicantsDtlsMyInfo.IDNum) { 
                                signatureId = docArray[i].id;
                                setSelectedSignature(getDefFileArray(docArray[i].File));
                                setUploadedSignature(docArray[i].File);
                                setIsSaveSignDone(true);
                            }
                        }

                        if(docArray[i].DocType === typeMemorandum) {  //Memorandum is only one 
                         
                            pdfId = docArray[i].id;
                            setSelectedPdf(getDefFileArray(docArray[i].File));
                            setUploadedPdf(docArray[i].File);
                            setIsSavePdfDone(true);
                        }

                        if(docArray[i].DocType === typeACS) {  //Memorandum is only one 
                            acsId = docArray[i].id;
                            setSelectedPdfACS(getDefFileArray(docArray[i].File));
                            setUploadedPdfACS(docArray[i].File);
                            setIsSaveDone(true);
                        }
                    }
                }
            }
            else {
                signatureId = '0';
                pdfId = '0';
                acsId= '0';
                setIsSaveDone(false);
                setIsSavePdfDone(false);
                setIsSaveSignDone(false);
                setSelectedSignature([]);
                setSelectedPdf([]);
                setSelectedPdfACS([]);
            }
        }catch(ex) {
          
        }
         
        setIsLoading(false);
    }

    
    const bindDocClare = (data) => {

        if(data.DocSubmit.DocClare !== undefined) {
            setInitFormData({DocClare:getBindDocClare(data) === 'true'? true:false})
        }
        else {
            setInitFormData({DocClare:false})
        }
    }

    const getBindDocClare = (data) => {
  
        if(getLoginUserOrder(data) === seq0) {
            return data.DocSubmit.DocClare.AuthPerSeq0;
        }
        if(getLoginUserOrder(data) === seq1) {
            return data.DocSubmit.DocClare.AuthPerSeq1;
        }
        if(getLoginUserOrder(data) === seq2) {
            return data.DocSubmit.DocClare.AuthPerSeq2;
        }
        if(getLoginUserOrder(data) === seq3) {
            return data.DocSubmit.DocClare.AuthPerSeq3;
        }
    }

    const formatDocClare = () => {
        let params = {
            AuthPerSeq0:getLoginUserOrder(response) === seq0? true:false,
            AuthPerSeq1:getLoginUserOrder(response) === seq1? true:false,
            AuthPerSeq2:getLoginUserOrder(response) === seq2? true:false,
            AuthPerSeq3:getLoginUserOrder(response) === seq3? true:false
        };

        return params;
    }

    const getDefFileArray = (file) => {
        let fileArray = [];
        let fileData = {
            extension:file.extension,
            name:file.name,
            progress: parseInt(file.progress),
            size: parseInt(file.size) ,
            status:parseInt(file.status),
            uid:file.uid
        }
        fileArray.push(fileData);

        return fileArray;
    }

    const isNonAuthPerson = () => {
        let applicantArray = [];
        if(response.ApplicantDtls.length === undefined){
            applicantArray.push(response.ApplicantDtls);
        }
        else {
            applicantArray = response.ApplicantDtls;
        } 

        if(response.ApplicantsDtlsMyInfo){
            const authPerson = helper.getObjInArraybyIDNum(response.ApplicantsDtlsMyInfo.IDNum,applicantArray);
            if(authPerson === undefined){  //non auth person
                return true;
            }
            else if(authPerson.ApplicantSeq === seq0) { // non auth person
                return true;
            }
            else {
                return false;
            }
        }
    }

    const isFirstUser = () => {
        if(response.ApplicantsDtlsMyInfo){
            if(response.ApplicantsDtlsMyInfo.isFirstUser === "true"){  
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }

    const handleSubmit = (dataItem) => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        saveUploadDetails();
    }
 
    const uploadSignature = (file) => {
        setIsUploading(true);
        let signRawFile = file[0].getRawFile();
        let signName = response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+file[0].extension;
        uploadService.uploadFiles(signRawFile,response.RefNum,signName,typeSignature,signatureId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess){
                signatureId = resData.model.id;
                saveSignature(file);
            }
            else{
             
                setIsUploading(false);
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
            }
        }).catch(err => {
      
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
        })
    }

    
    const saveSignature = (file) => {
     
        let docArray = [];
        docArray.push({
            DocType: typeSignature,
            DocName: response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+file[0].extension,
            NRIC:response.ApplicantsDtlsMyInfo.IDNum,
            Name:response.ApplicantsDtlsMyInfo.Name,
            id:signatureId,
            File:{
                extension:file[0].extension,
                name:file[0].name,
                progress:file[0].progress,
                size: file[0].size,
                status: file[0].status,
                uid: file[0].uid
            }
        })

        if(isFirstUser()) {  // only first user will upload memorandum and acs

            if(selectedPdf.length !== 0) { // Yes or No, Memo will upload 
                let pdf = {
                    DocType: typeMemorandum,
                    DocName: response.RefNum+'_'+typeMemorandum+selectedPdf[0].extension,
                    id:pdfId,
                    File: {
                        extension:selectedPdf[0].extension,
                        name:selectedPdf[0].name,
                        progress:selectedPdf[0].progress,
                        size: selectedPdf[0].size,
                        status: selectedPdf[0].status,
                        uid: selectedPdf[0].uid
                    }
                }
                docArray.push(pdf);
            }

            if(selectedPdfACS.length !== 0) {
                let pdf = {
                    DocType: typeACS,
                    DocName: response.RefNum+'_'+typeACS+selectedPdfACS[0].extension,
                    id:acsId,
                    File: {
                        extension:selectedPdfACS[0].extension,
                        name:selectedPdfACS[0].name,
                        progress:selectedPdfACS[0].progress,
                        size: selectedPdfACS[0].size,
                        status: selectedPdfACS[0].status,
                        uid: selectedPdfACS[0].uid
                    }
                }
                docArray.push(pdf);
            }
        }

        let params = {
            DocSubmit:{
                AdoptAcraTemplate: checkedAdoptAcraTemplate,
                Doc: docArray,
                DocClare:false
            },
            CurrentUser:currentUser(),
      
        }

        service.post(detailsType,params).then( res => {
            setIsUploading(false);  
            let resData = res.data;
            if(resData.isSucess) {
                setIsSaveSignDone(true);
                setUploadedSignature(params.DocSubmit.Doc[0].File)
                hideSignErrMsg();
            }
            else {
                resetSignature();
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showSignErrMsg(config.error.UploadDetails.UploadFailed);
            }  
        })
        .catch(err => {
            // console.log('saveSignature',err)
            resetSignature();
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showSignErrMsg(config.error.UploadDetails.UploadFailed);
        });
    }

    const resetSignature = () => {
        setIsSaveSignDone(false);
        setSelectedSignature([]);
    }

    const uploadPdf = (pdfFile) => {
        setIsUploading(true);
        let rawFile = pdfFile[0].getRawFile();
        let docName = response.RefNum+'_'+typeMemorandum+pdfFile[0].extension;
        uploadService.uploadFiles(rawFile,response.RefNum,docName,typeMemorandum,pdfId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess) {
                pdfId= resData.model.id;
                savePdfDoc();
            }
            else {
                setIsUploading(false);
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showPdfMemoErrMsg(config.error.UploadDetails.UploadFailed);
            }
        }).catch(err => {
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showPdfMemoErrMsg(config.error.UploadDetails.UploadFailed);
        })
    }

    const savePdfDoc = (pdfFile) => {
        let docArray = []; 
        docArray.push(
            {
                DocType: typeMemorandum,
                DocName: response.RefNum+'_'+typeMemorandum+pdfFile[0].extension,
                id:pdfId,
                File: {
                    extension:pdfFile[0].extension,
                    name:pdfFile[0].name,
                    progress:pdfFile[0].progress,
                    size: pdfFile[0].size,
                    status: pdfFile[0].status,
                    uid: pdfFile[0].uid
                }
            }
        )
        //current login user selected files
        if(selectedSignature.length !== 0){
            let sign = {
                DocType: typeSignature,
                DocName: response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+selectedSignature[0].extension,
                NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                Name:response.ApplicantsDtlsMyInfo.Name,
                id:signatureId,
                File:{
                    extension:selectedSignature[0].extension,
                    name:selectedSignature[0].name,
                    progress:selectedSignature[0].progress,
                    size: selectedSignature[0].size,
                    status: selectedSignature[0].status,
                    uid: selectedSignature[0].uid
                }
            }
            docArray.push(sign);
        }
        
        if(isFirstUser()) {  // only first user will upload memorandum and acs
            if(selectedPdfACS.length !== 0) {
                let pdf = {
                    DocType: typeACS,
                    DocName: response.RefNum+'_'+typeACS+selectedPdfACS[0].extension,
                    id:acsId,
                    File: {
                        extension:selectedPdfACS[0].extension,
                        name:selectedPdfACS[0].name,
                        progress:selectedPdfACS[0].progress,
                        size: selectedPdfACS[0].size,
                        status: selectedPdfACS[0].status,
                        uid: selectedPdfACS[0].uid
                    }
                }
                docArray.push(pdf);
            }
        }
        let params = {
            DocSubmit:{
                AdoptAcraTemplate:checkedAdoptAcraTemplate,
                Doc:docArray,
                DocClare:false
            },
            CurrentUser:currentUser()
        }

        service.post(detailsType,params).then( res => {
            setIsUploading(false);
            let resData = res.data;
            if(resData.isSucess) {
                setIsSavePdfDone(true);
                setUploadedPdf(params.DocSubmit.Doc[0].File);
                hidePdfMemoErrMsg();
            }
            else {
                resetPdf();
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showPdfMemoErrMsg(config.error.UploadDetails.UploadFailed);
            }          
        })
        .catch(err => {
            resetPdf();
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showPdfMemoErrMsg(config.error.UploadDetails.UploadFailed);
        });
    }
    
    const resetPdf = () => {
        setIsSavePdfDone(false);
        setSelectedPdf([]);
    }

    const uploadACS = (acsFile) => {
    
        setIsUploading(true);
        let rawFile = acsFile[0].getRawFile();
        let docName = response.RefNum+'_'+typeACS+acsFile[0].extension;
        uploadService.uploadFiles(rawFile,response.RefNum,docName,typeACS,acsId)
        .then( res => {
            let resData = res.data;
            if(resData.isSucess) {
                acsId = resData.model.id;
                saveACSDoc(acsFile);
            }
            else{
                setIsUploading(false);
                showErrMsg(resData.errorMessage);
                showPdfACSErrMsg(resData.errorMessage);
            }
        }).catch(err => {
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showPdfACSErrMsg(config.error.UploadDetails.UploadFailed);
        })
    }

    const saveACSDoc = (pdfFile) => {
        let docArray = []; 
        docArray.push({
            DocType: typeACS,
            DocName: response.RefNum+'_'+typeACS+pdfFile[0].extension,
            id:acsId,
            File: {
                extension:pdfFile[0].extension,
                name:pdfFile[0].name,
                progress:pdfFile[0].progress,
                size: pdfFile[0].size,
                status: pdfFile[0].status,
                uid: pdfFile[0].uid
            }
        })

        //current login user selected files
        if(selectedSignature.length !== 0){
            let sign = {
                DocType: typeSignature,
                DocName: response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+selectedSignature[0].extension,
                NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                Name:response.ApplicantsDtlsMyInfo.Name,
                id:signatureId,
                File:{
                    extension:selectedSignature[0].extension,
                    name:selectedSignature[0].name,
                    progress:selectedSignature[0].progress,
                    size: selectedSignature[0].size,
                    status: selectedSignature[0].status,
                    uid: selectedSignature[0].uid
                }
            }
            docArray.push(sign);
        }
        
        if(isFirstUser()) {  // only first user will upload memorandum and acs
            if(checkedAdoptAcraTemplate === 'N') { // AdoptAcraTemplate==='N', only then submit
                if(selectedPdf.length !== 0) {
                    let pdf = {
                        DocType: typeMemorandum,
                        DocName: response.RefNum+'_'+typeMemorandum+selectedPdf[0].extension,
                        id:pdfId,
                        File: {
                            extension:selectedPdf[0].extension,
                            name:selectedPdf[0].name,
                            progress:selectedPdf[0].progress,
                            size: selectedPdf[0].size,
                            status: selectedPdf[0].status,
                            uid: selectedPdf[0].uid
                        }
                    }
                    docArray.push(pdf);
                }
            }
        }
        
        let params = {
            DocSubmit:{
                AdoptAcraTemplate:checkedAdoptAcraTemplate,
                Doc:docArray,
                DocClare:false
            },
            CurrentUser:currentUser()
        }

        service.post(detailsType,params).then( res => {
            setIsUploading(false);
            let resData = res.data;
            if(resData.isSucess) {
                setIsSaveDone(true);
                setUploadedPdfACS(params.DocSubmit.Doc[0].File);
                hidePdfACSErrMsg();
            }
            else {
                resetACSPdf();
                showErrMsg(config.error.UploadDetails.UploadFailed);
                showPdfACSErrMsg(config.error.UploadDetails.UploadFailed);
            }          
        })
        .catch(err => {
            resetPdf();
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
            showPdfACSErrMsg(config.error.UploadDetails.UploadFailed);
        });
    }
    
    const resetACSPdf = () => {
        setIsSaveDone(false);
        setSelectedPdfACS([]);
    }


    const saveUploadDetails = () => {
        let params = {
            DocSubmit:{
                AdoptAcraTemplate:checkedAdoptAcraTemplate,
                Doc: getDocArray(),
                DocClare:formatDocClare()
            },
            CurrentUser:currentUser()
        }
        service.post(detailsType,params).then( res => {
            setIsUploading(false);
            let resData = res.data;
            if(resData.isSucess) {
                goNext();
            }
            else {
                showErrMsg(resData.errorMessage);
            }          
        })
        .catch(err => {
            setIsUploading(false);
            showErrMsg(config.error.UploadDetails.UploadFailed);
        });
    }

    const getDocArray = () => {
 
        let docArray = []; 
 
        //current login user selected files
        if(selectedSignature.length !== 0){
            let sign = {
                DocType: typeSignature,
                DocName: response.ApplicantsDtlsMyInfo.IDNum+'_'+typeSignature+selectedSignature[0].extension,
                NRIC:response.ApplicantsDtlsMyInfo.IDNum,
                Name:response.ApplicantsDtlsMyInfo.Name,
                id:signatureId,
                File:{
                    extension:selectedSignature[0].extension,
                    name:selectedSignature[0].name,
                    progress:selectedSignature[0].progress,
                    size: selectedSignature[0].size,
                    status: selectedSignature[0].status,
                    uid: selectedSignature[0].uid
                }
            }
            docArray.push(sign);
        }
        
        if(isFirstUser()) {  // only first user will upload memorandum and acs
            if(checkedAdoptAcraTemplate === 'N') { // AdoptAcraTemplate==='N', only then submit
                if(selectedPdf.length !== 0) {
                    let pdf = {
                        DocType: typeMemorandum,
                        DocName: response.RefNum+'_'+typeMemorandum+selectedPdf[0].extension,
                        id:pdfId,
                        File: {
                            extension:selectedPdf[0].extension,
                            name:selectedPdf[0].name,
                            progress:selectedPdf[0].progress,
                            size: selectedPdf[0].size,
                            status: selectedPdf[0].status,
                            uid: selectedPdf[0].uid
                        }
                    }
                    docArray.push(pdf);
                }
            }

            if(selectedPdfACS.length !== 0) {
                let pdf = {
                    DocType: typeACS,
                    DocName: response.RefNum+'_'+typeACS+selectedPdfACS[0].extension,
                    id:acsId,
                    File: {
                        extension:selectedPdfACS[0].extension,
                        name:selectedPdfACS[0].name,
                        progress:selectedPdfACS[0].progress,
                        size: selectedPdfACS[0].size,
                        status: selectedPdfACS[0].status,
                        uid: selectedPdfACS[0].uid
                    }
                }
                docArray.push(pdf);
            }
        }
       
        return docArray;
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
            else {
                if(getLoginUserOrder(response) === '0') {
                    history.push(config.route.NonAuthPersonDetails, { from: config.route.ACSUploadDetails });
                }
                else {
                    if(isFirstUser()){ //first user
                        history.push(config.route.AcctOpeningMY, {from: config.route.ACSUploadDetails});
                    }
                    else { //subsequent AP
                        history.push(config.route.DeclarationDetails, { from: config.route.ACSUploadDetails });
                    }
                }
            }
        }
        else {
            if(getLoginUserOrder(response) === '0') {
                history.push(config.route.NonAuthPersonDetails, { from: config.route.ACSUploadDetails });
            }
            else {
                if(isFirstUser()){ //first user
                    history.push(config.route.AcctOpeningMY, {from: config.route.ACSUploadDetails});
                }
                else { //subsequent AP
                    history.push(config.route.DeclarationDetails, { from: config.route.ACSUploadDetails });
                }
            }
        }
    }

    const disabledNextBtn = () => {
        let disable = true;
        if(!isNonAuthPerson()) { //First User, Authorised Person
            if(checkedAdoptAcraTemplate === 'Y') {
               if(selectedSignature.length !== 0  ) {  //director or holders
                    disable = false;
                }
                else {
                    disable = true;
                }
            }
            else { //'N'
                
                if(selectedSignature.length !==0 && selectedPdf.length !== 0) {  //director or holders
                    disable = false;
                }
                else {
                    disable = true;
                }
            }
        }
        else { //Non authorised Person
            if(checkedAdoptAcraTemplate === 'Y') {
                disable = false;
            }
            else if(checkedAdoptAcraTemplate === 'N' && selectedPdf.length !== 0) {
                disable = false;
            }
            else {
                disable = true;
            }
        }
      
        return disable;
    }

    const currentUser = () => {
        let params = {};
        params = {
            IDNum: response.ApplicantsDtlsMyInfo.IDNum,
            Seq:getLoginUserSeq(),
            Order:getLoginUserOrder(response)
        }
        return params
    }

    const getLoginUserOrder = (resObj) => {
        let authSeq = '', isAuthPerson = false;
        if(!Array.isArray(resObj.ApplicantDtls)){ //check obj or array
            if(resObj.ApplicantDtls.IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum){
                authSeq = resObj.ApplicantDtls.ApplicantSeq;
                isAuthPerson = true;
            }
            else {  //non login user
                authSeq = '0';
                isAuthPerson = false;
            }
        }
        else { //array
            for(let i in resObj.ApplicantDtls) {
                if(resObj.ApplicantDtls[i].IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum) {  // get login user's seq number 
                    authSeq = resObj.ApplicantDtls[i].ApplicantSeq;
                    isAuthPerson = true;
                }
            }
        }
        if(isAuthPerson){
            return authSeq;
        }
        else {
            return '0';
        }
    }

    const getLoginUserSeq = () => {
        if(isFirstUser()){  // first user
            return '0';
        }
        else {  // not first user
            if(!Array.isArray(response.ApplicantDtls)){ //check obj
                if(response.ApplicantDtls.IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                    return response.ApplicantDtls.ApplicantSeq;
                }
            }
            else { //array
                for(let i in response.ApplicantDtls){
                    if(response.ApplicantDtls[i].IDNum ===  response.ApplicantsDtlsMyInfo.IDNum){
                        return response.ApplicantDtls[i].ApplicantSeq;
                    }
                }
            }
        }
    }

    const isValidSignature = (file) => {
        let isValid = false;
        try{
            if(file.length !== 0) {
                let fileObj = file[0];
                let size = fileObj.size;
                let extn = fileObj.extension.toLowerCase();
                if(extn === '.png' || extn === '.jpg' || extn === '.jpeg') {
                    if(size <= 3145728) {
                        isValid = true;
                    }
                    else {
                        isValid = false;
                    }
                }
                else { 
                     isValid = false;
                 }
            }
            else{
                isValid = false;
            }
            return isValid;
        }catch(ex){
        
        }

        return isValid;
    }

    const isValidPdf = (pdfFile) => {
        let isValid = false;
        try{
            if(pdfFile.length !== 0) {
                let fileObj = pdfFile[0];
                let size = fileObj.size;
                let extn = fileObj.extension.toLowerCase();

                if(extn === '.pdf') {
                    if(size <= 5242880) {
                        isValid = true;
                    } 
                    else {
                        isValid = false;
                    }
                 }
                 else {
                     isValid = false;
                 }
            }
            else{
                isValid = false;
            }
            return isValid;
        }catch(ex){
        
        }

        return isValid;
    }

    const isValidPdfFileName = (pdfFile) => {

        let fileObj = pdfFile[0];
        let fileName = fileObj.name;
        let isValid = true;
        if(pdfFileNameCharRegex.test(fileName)) {
            isValid = false;
        }
        return isValid;
    }


    const onHandleChange = (data) => {
        setSelectedSignature(data.value);
        if(data.value.length !== 0) {
            if(!isValidSignature(data.value)) {
                resetSignature();
                showErrMsg(uploadConfig.errMsg.imgSize3MB);
                showSignErrMsg(uploadConfig.errMsg.imgSize3MB);
                return;
            }
            uploadSignature(data.value);
        } 
    }

    const onHandlePdfDocChange = (data) =>{
        setSelectedPdf(data.value);
        if(data.value.length !== 0) {
            if(!isValidPdf(data.value)){
                resetPdf();
                showErrMsg(uploadConfig.errMsg.pdfSize5MB);
                showPdfMemoErrMsg(uploadConfig.errMsg.pdfSize5MB);
                return;
            }

            if(!isValidPdfFileName(data.value)) {
                resetPdf();
                showErrMsg(uploadConfig.errMsg.pdfNameSpecChars);
                showPdfMemoErrMsg(uploadConfig.errMsg.pdfNameSpecChars);
                return;
            }

            let fContent = data.value[0].getRawFile();
            let fdata;
            let reader = new FileReader();
            reader.readAsText(fContent, "UTF-8");
            reader.onload = function (evt) {
                fdata = evt.target.result;
                if (fdata != "" &&  fdata.indexOf("Encrypt") > 0) {
                    resetPdf();
                    showErrMsg(uploadConfig.errMsg.encryptedPdf);
                    showPdfMemoErrMsg(uploadConfig.errMsg.encryptedPdf);
                }
                else {
                    uploadPdf(data.value);
                }
            }
        }
    }

    const onHandlePdfACSChange = (data) =>{
        setSelectedPdfACS(data.value);
        if(data.value.length !== 0) {
            if(!isValidPdf(data.value)){
                resetACSPdf();
                showErrMsg(uploadConfig.errMsg.pdfSize5MB);
                showPdfACSErrMsg(uploadConfig.errMsg.pdfSize5MB);
                return;
            }

            if(!isValidPdfFileName(data.value)) {
                resetACSPdf();
                showErrMsg(uploadConfig.errMsg.pdfNameSpecChars);
                showPdfACSErrMsg(uploadConfig.errMsg.pdfNameSpecChars);
                return;
            }
            
            let fContent = data.value[0].getRawFile();
            let fdata;
            let reader = new FileReader();
            reader.readAsText(fContent, "UTF-8");
            reader.onload = function (evt) {
                fdata = evt.target.result;
                if (fdata != "" &&  fdata.indexOf("Encrypt") > 0) {
                    resetACSPdf();
                    showErrMsg(uploadConfig.errMsg.encryptedPdf);
                    showPdfACSErrMsg(uploadConfig.errMsg.encryptedPdf);
                }
                else {
                    uploadACS(data.value);
                }
            }
        }
    }

    const checkEncruptedPdf = ( pdfFiles) => {
 
        if(pdfFiles.length) {
            let fContent = pdfFiles[0].getRawFile();
            let fdata;
            let reader = new FileReader();
            reader.readAsText(fContent, "UTF-8");
            reader.onload = function (evt) {
                fdata = evt.target.result;
                if (fdata != "" &&  fdata.indexOf("Encrypt") > 0) {
                 
                    return true;
                }
                else {
                    return false;
                }
            }
        }
    }

    const onAdoptAcraTemplateChange = (e) => {
        setCheckedAdoptAcraTemplate(e.value);
        setSelectedPdf([]);
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const showPdfMemoErrMsg = (msg) => {
        setUploadMemoErr(true);
        setMemoErrMsg(msg);
    }
    
    const hidePdfMemoErrMsg = () => {
        setUploadMemoErr(false);
        setMemoErrMsg('');
    }

    const showPdfACSErrMsg = (msg) => {
        setUploadACSErr(true);
        setACSErrMsg(msg);
    }
    
    const hidePdfACSErrMsg = () => {
        setUploadACSErr(false);
        setACSErrMsg('');
    }

    const showSignErrMsg = (msg) => {
        setUploadSignErr(true);
        setSignErrMsg(msg);
    }
    
    const hideSignErrMsg = () => {
        setUploadSignErr(false);
        setSignErrMsg('');
    }

    const getAuthPerName = () =>{
        if(response.ApplicantsDtlsMyInfo.Name !==null) { //always login user
           return '(Authorised Person '+getLoginUserOrder(response)+' - '+response.ApplicantsDtlsMyInfo.Name+')';
        }
        else {
            return '';
        }
    }

    const handleBackBtnClick = (e) =>{
        e.preventDefault();
        if(isFirstUser()){
            history.push(config.route.NSTaxDetails);
        }
        else {
            if(!isFirstUser()){
                history.push(config.route.NSDelegationDetails);
            }
            else {
                history.push(config.route.NSDelegationDetails2);
            }
        }
    }
    const downloadPdf = (refNo,docType,docId,docName) => {
        const pdfUrl = uploadService.getPdfFileUrl(refNo,docType,docId,docName);
        //window.open(pdfUrl);
        axios({
            url: pdfUrl, //your url
            method: 'GET',
            responseType: 'blob', // important
            headers: {
                "Content-Type": "application/octet-stream",
                'Authorization': "Maybank" + " " +storage.getToken()
            }
            }).then((response) => {
                const dFileName = docName+".pdf"
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', dFileName ); //or any other extension
                document.body.appendChild(link);
                link.click();
        });
    }

    const getUploadFile = (refNo,docType,docId) => {
      
        setIsUploading(true);
        uploadService.getFile(refNo,docType,docId).then( res => {
            if(res.data.isSucess) {
                setIsUploading(false);
                if(docType === typeMemorandum) {  //pdf
                    let pdfWindow = window.open("")
                    pdfWindow.document.write("<html<head><title>"+uploadedPdf.name+"</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
                    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(res.data.model.imageFields)+"#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
                }
                else if(docType === typeACS){
                    let pdfWindow = window.open("")
                    pdfWindow.document.write("<html<head><title>"+uploadedPdfACS.name+"</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");
                    pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(res.data.model.imageFields)+"#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>");
                }
                else { //signature img
                    imgStr = 'data:image/png;base64,'+res.data.model.imageFields;
                    setShowImgPopup(true);
                }
            }
            else{
                setIsUploading(false);
            }
        })
        .catch(err=> {
            setIsUploading(false);
            showErrMsg('Error: Get upload file failed.')
        })
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }
    
    return(
        <div className="container-fluid">
           <div className="outerdivsubheader">
                <div className="row">
                    <div className="col-12">
                        <h2 className='welcome mb-0'>Business Account Opening<br/>SME Banking</h2>
                    </div>
                </div>
            </div> <br/>
            <Form onSubmitClick={handleSubmit}
                initialValues={initFormData}
                key={JSON.stringify(initFormData)}
                render={(formRenderProps)=>(
                <FormElement>
                <FormContainer>
                    <fieldset>
                        <Field component={FormTitle} id={'ft1'} name={'Your Additional Business Details'}/> 
                        <FieldWrapper style={{paddingBottom:'20px'}}>
                            <Field component={CusFormLabel} 
                                leftLabelId={'lblCapAmt'} leftLabelName={'Issued Capital Amount (Ordinary Shares)'}
                                id={'CapAmt'} name={response.CompDtls.IssuedCapitalAmount !=="null"? response.CompDtls.IssuedCapitalAmount:'Not applicable'} />
                            <Field component={CusFormLabel} 
                                leftLabelId={'lblBizName'} leftLabelName={'Business Former Name'}
                                id={'BizName'} name={response.CompDtls.FormerName !==null?response.CompDtls.FormerName:'Not applicable'} />
                        </FieldWrapper>
                    </fieldset>
                </FormContainer>

                <FormContainer>
                    <fieldset>
                        <Field component={FormTitle} id={'ft2'} name={'Upload Supporting Documents'} /> 
                        {!isNonAuthPerson() && <div>
                        <Field id={'Doc'} name={'Doc'} label={'An image of your signature \n'+getAuthPerName()}
                            isTooltipImg={true}
                            tooltipPosition={'right'} tooltipAchor={'target'} tooltipTitle={'Sign in black on white piece of paper.'}
                            tooltipDesc={uploadConfig.label.signTTip}
                            component={FormUploadView} 
                            defaultFiles={selectedSignature}
                            onChange={onHandleChange} 
                            isFileUploaded={isSaveSignDone && uploadedSignature? true:false}
                            uploadedFileName={isSaveSignDone && uploadedSignature? uploadedSignature.name:''}
                            onViewClick={e => {
                                e.preventDefault();
                                getUploadFile(response.RefNum,typeSignature,signatureId);
                            }} />
                            {uploadSignErr && 
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <Error id={'errId1'}>{signErrMsg}</Error> 
                                </div>
                            </div>}
                        </div>
                        }

                        <FieldWrapper>
                        <CusRadioButton name="AdoptAcraTemplate" leftValue='Y' rightValue='N' 
                            label={'Your company adopts the Standard ACRA template constitution'} 
                            disabled={!isFirstUser()} 
                            onChange={onAdoptAcraTemplateChange} checkedValue={checkedAdoptAcraTemplate} />
                        </FieldWrapper>

                        {checkedAdoptAcraTemplate !== null &&  
                        <div>
                        <Field id={'PdfDoc'} name={'PdfDoc'} component={FormUploadView} defaultFiles={selectedPdf}
                            disabled={!isFirstUser()}
                            label={'Certified true copies of Memorandum & Articles of Association (M&A)/By-laws/Constitution'}
                            isTooltipImg={false} tooltipPosition={'right'} tooltipAchor={'target'} 
                            tooltipTitle={'You may upload your file in a pdf format (up to 5 MB).'}
                            onChange={onHandlePdfDocChange} 
                            isFileUploaded={isSavePdfDone && uploadedPdf? true:false}
                            uploadedFileName={isSavePdfDone && uploadedPdf? uploadedPdf.name:''}
                            onViewClick={e => {
                                e.preventDefault();
                                let oriPdfName = uploadedPdf.name;
                                let pdfNameArray = oriPdfName.split('.');
                                const pdfName = pdfNameArray[0];
                                downloadPdf(response.RefNum,typeMemorandum,pdfId,pdfName);
                            }} />
                            {uploadMemoErr && 
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <Error id={'errId2'}>{memoErrMsg}</Error> 
                                </div>
                            </div>} 
                            </div>}

                        <Field id={'PdfDocACS'} name={'PdfDocACS'} component={FormUploadView} defaultFiles={selectedPdfACS}
                            disabled={!isFirstUser()}
                            label={'Certified true copy of Minutes of meeting reflecting list of office bearers'}
                            isTooltipImg={false} tooltipPosition={'right'} tooltipAchor={'target'} 
                            tooltipTitle={'You may upload your file in a pdf format (up to 5 MB).'}
                            onChange={onHandlePdfACSChange}
                            isFileUploaded={isSaveDone && uploadedPdfACS? true:false}
                            uploadedFileName={isSaveDone && uploadedPdfACS? uploadedPdfACS.name:''}
                            onViewClick={e => {
                                e.preventDefault();
                                let oriPdfACSName = uploadedPdfACS.name;
                                let pdfNameArray = oriPdfACSName.split('.');
                                const pdfACSName = pdfNameArray[0];
                                downloadPdf(response.RefNum,typeACS,acsId,pdfACSName);
                            }}  />
                        
                        {uploadACSErr && 
                            <div className="row around-xs inputPair elementVisible">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <Error id={'errId3'}>{acsErrMsg}</Error> 
                                </div>
                            </div>} 

                        <FieldWrapper>
                        <Field name={'DocClare'} label={uploadConfig.label.declare}  id={'termsinput'}
                            component={TermsFormCheckbox} validator={uploadTermsValidator} value={true}/>
                        </FieldWrapper>
                       

                        <FieldWrapper>
                        <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />
                        <div className="row around-xs inputPair elementVisible">
                            <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                                <button type={"button"} className="btn btn-back" 
                                    onClick={handleBackBtnClick}>{config.btnName.Back}</button>
                                <button type={'submit'} className="k-button btn btn-success btn-float-right" disabled={disabledNextBtn() || !formRenderProps.valid} >{config.btnName.Next}</button>
                            </div>
                        </div> 
                        </FieldWrapper>
                        {isUploading&&<Loading />}

                        {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'}
                            onClose={()=>{ setIsError(false)}} />} */}
                        <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} /> 

                        <ImgPopup popupTitle={uploadedSignature? uploadedSignature.name:'Preview'} popupValue={showImgPopup} data={imgStr} setTrigger={setShowImgPopup}  />
                    </fieldset>
                </FormContainer>
            </FormElement>
            )}>
           </Form>
        </div>
    )
}

export default ACSUploadDetails